var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGitlab = function SvgGitlab(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E24329",
    d: "m15.734 6.1-.023-.058L13.533.358a.568.568 0 0 0-.563-.356.583.583 0 0 0-.327.122.583.583 0 0 0-.193.294l-1.47 4.498H5.024L3.555.418A.571.571 0 0 0 2.47.358L.289 6.038l-.022.058a4.044 4.044 0 0 0 1.341 4.674l.008.006.02.014 3.317 2.484 1.642 1.242 1 .755a.672.672 0 0 0 .812 0l1-.755 1.641-1.242 3.338-2.5.008-.006a4.046 4.046 0 0 0 1.34-4.669Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "m15.734 6.1-.023-.058a7.357 7.357 0 0 0-2.928 1.316L8 10.975c1.629 1.232 3.047 2.302 3.047 2.302l3.337-2.499.008-.007A4.045 4.045 0 0 0 15.734 6.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA326",
    d: "m4.953 13.277 1.642 1.243 1 .754a.672.672 0 0 0 .812 0l1-.754 1.641-1.243S9.628 12.203 8 10.975a2323.726 2323.726 0 0 0-3.047 2.302Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6D26",
    d: "M3.216 7.358A7.347 7.347 0 0 0 .29 6.038l-.022.058a4.044 4.044 0 0 0 1.341 4.674l.008.006.02.014 3.317 2.484L8 10.971 3.216 7.358Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGitlab);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;